import React, { useEffect, useState } from "react";
import {
  TableHead,
  TableBody,
  Table,
  TableContainer,
  TableCell,
  TableRow,
  Box,
  Button,
  TextField,
  Typography,
  TablePagination,
  InputAdornment,
  IconButton,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import './LoansApprovedPage.scss';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { commonRunQuery, getListOfLoansToApprove, loanApprove, loanCancel, loanPaymentPlanRetrieve, postAdjustmentNoPin10 } from "../../util/API/loans";
import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import dayjs from "dayjs";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { format, parseISO } from "date-fns";
import SearchIcon from "@mui/icons-material/Search";
import CustomInputAlert from "../UI/CustomInputAlert/CustomInputAlert";
import BaseDrawer from "../UI/BaseDrawer/BaseDrawer";
import LoanDetails4Pay from "../LoanDetails4Pay/LoanDetails4Pay";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";
import { getExternalAccounts } from "../../util/API/externalaccounts";
import { LOANS_ACCOUNT_NO } from "../../config";

const LoansApprovedPage = ({
    setViewApprovedLoans,
    selectedProductLoan,
    selectedUser,
    setAlert,
    setAlertOpen
}) => {
    const [searchText, setSearchText] = useState("");
    const [loanList, setLoanList] = useState([]);
    const [allLoans, setAllLoans] = useState([]);
    const [showInputAlert, setShowInputAlert] = useState(false);
    const [selectedLoan, setSelectedLoan] = useState(null);
    const authUser = sessionStorage.getItem("user");
    const parsedAuthUser = JSON.parse(authUser);
    const [startDate, setStartDate] = useState(dayjs().subtract(30, "day")); // Default to 30 days ago
    const [endDate, setEndDate] = useState(dayjs());
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openLoanDetailsDrawer, setOpenLoanDetailsDrawer] = useState(false);
    const [loanDetailsArr, setDetailsArr] = useState(false);
    const [userLoanPaymentPlans, setUserLoanPaymentPlans] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
    const [openDetailsDrawer, setOpenDetailsDrawer] = useState(false);
    const [userTransactionAccArr, setUserTransactionAccArr] = useState([]);

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
        // backgroundColor: "rgba(0,0,0, .1)",
        color: theme.palette.common.black,
        fontWeight: "bold",
        textAlign:"center",
        },
        [`&.${tableCellClasses.body}`]: {
        fontSize: 25,
        fontWeight: "600",
        },
    }));

    useEffect(()=> {
        getApprovedLoansList();
        getUserAccounts();
    },[selectedUser, selectedProductLoan, startDate, endDate]);

    const getUserAccounts = async() => {
        let response = await getExternalAccounts(selectedUser);
        console.log("getUserAccounts===============", response);
        let records = response.payload?.record;
        if (!records) return;
        if (!Array.isArray(records)) {
        records = [records];
        }
        // Separate transaction accounts from other accounts
        const transactionAccounts = records.filter((account) =>
            account.Vuserpi3?.friendlyname?.toLowerCase().includes("transaction")
        );

        setUserTransactionAccArr(transactionAccounts);
        console.log("transactionAccounts===============", transactionAccounts[0]?.Vuserpi3);
    }

    const getApprovedLoansList = async() => {
        try {
            console.log("StartDate=======================",startDate);
            console.log("EndDate=======================",endDate);
            const formattedStartDate = startDate.format("YYYY-MM-DD");
            const formattedEndDate = endDate.format("YYYY-MM-DD");
            console.log("formattedStartDate=======================",formattedStartDate);
            console.log("formattedEndDate=======================",formattedEndDate);

            const response = await getListOfLoansToApprove(232, `${selectedUser}/${selectedProductLoan?.productcode}/${formattedStartDate}/${formattedEndDate}`);
            // const response = await getListOfLoansToApprove(243, `${selectedUser}/${selectedProductLoan?.productcode}/${formattedStartDate}/${formattedEndDate}/${rowsPerPage}/${page}`);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const loanProductsArray = Array.isArray(response?.data?.body?.record)
                  ? response?.data?.body?.record
                  : [response?.data?.body?.record];
                
                console.log("getLoansList_loanProductsArray=======================",loanProductsArray);
                setLoanList(loanProductsArray);
                setAllLoans(loanProductsArray);
            } else if(response?.data?.header?.reccount === "0") {
                setLoanList([]);
                setAllLoans([]);
            }
        } catch (error) {
            console.log("getLoansList_error=======================",error);
        } finally {
            setIsLoading(false);
        }
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearch = () => {
        if (!searchText.trim()) {
            setLoanList(allLoans); // Reset to original data if search is cleared
            return;
        }
    
        const filteredLoans = allLoans.filter((row) => {
            return (
                row?.loanissued?.currcode?.toLowerCase().includes(searchText.toLowerCase()) ||
                row?.loanissued?.totalamount?.toLowerCase().includes(searchText.toLowerCase()) ||
                row?.loanissued?.issueddate?.toString().includes(searchText) ||
                row?.loanissued?.outstandinglatefees?.toLowerCase().includes(searchText.toLowerCase()) ||
                row?.loanissued?.outstandingprinciple?.toLowerCase().includes(searchText.toLowerCase())
            );
        });
    
        setLoanList(filteredLoans);
    }

    const cancelLoanConfirmation = async(rowData) => {
        setSelectedLoan(rowData);
        setShowInputAlert((prevState) => ({
            ...prevState,
            showAlert: true,
            severity: "confirm",
            message: "Are you sure you want to cancel this loan?",
            header: "Cancel Loan?",
            alertType: "confirm",
            inputLabel: "Reason",
            onConfirm: (reason) => {
                handleLoanCancellation(reason, rowData); // Pass rowData directly
            },
        }));
    }

    const handleLoanCancellation = async(reason, rowData) => {
        try {
            console.log("selectedLoan=======================",rowData);
            console.log("handleLoanCancellation=======================",reason);
            const response = await loanCancel("", selectedUser, rowData?.loanissued?.loanid, 1, reason, "");
            console.log("handleLoanCancellation_response=======================",response);
            if(response?.data?.header?.callStatus === "1") {
                let transactions = [
                    {
                        accountnumber: LOANS_ACCOUNT_NO,
                        type: 1,  
                        amount: rowData?.loanissued?.outstandingprinciple,
                        transactiontype: 1,
                        negativebalanceallowed: 1,
                        positivebalanceallowed: 1,        
                    },
                    {
                        accountnumber: userTransactionAccArr[0]?.Vuserpi3?.acctID,
                        type: 2,
                        amount: rowData?.loanissued?.outstandingprinciple,
                        transactiontype: 1,
                        negativebalanceallowed: 1,
                        positivebalanceallowed: 0,     
                    }
                ];

                let reason = "Loan Cancelled";

                const response1 = await postAdjustmentNoPin10(
                    "", // location
                    0, // fromuserid
                    rowData?.loanissued?.userid, // touserid
                    rowData?.loanissued?.currcode, // currency
                    transactions, // transactions
                    reason, // reason
                    "", // externalrefid
                    0, // sourcepi
                    userTransactionAccArr[0]?.Vuserpi3?.piid, // targetpi
                    0, // sourceuserpi
                    userTransactionAccArr[0]?.Vuserpi3?.id, // targetuserpi
                    "", //clerkname
                    3, // transtypeid
                    userTransactionAccArr[0]?.Vuserpi3?.acctID, //recipientaccountno
                    "", // adminmsg
                    0, // channelid
                    selectedUser, //recipientuserid
                    0, //parentuserid
                );

                console.log("postAdjustmentNoPin10_response1---------------",response1);

                setAlert({
                    showAlert: true,
                    severity: "success",
                    message: "Loan cancelled successfully.",
                    header: "Congratulations!",
                });

                setAlertOpen(true);
            }

            await getApprovedLoansList();
        } catch (error) {
            console.log("handleLoanCancellation_error=======================",error);
        }
    }

    const handleDetailsBtn = async(row) => {
        try {
            let mainAmtArr = [];
            let lateFeesArr = [];

            const response = await commonRunQuery(237, row?.loanissued?.loanid);
            const lateFeeResponse = await commonRunQuery(240, row?.loanissued?.loanid);
            const loanPaymentPlanRetrieveRes = await loanPaymentPlanRetrieve("", row?.loanissued?.userid, row?.loanissued?.loanid)

            console.log("handleDetailsBtn_response=======================",response);
            console.log("handleDetailsBtn_response=======================",lateFeeResponse);
            
            if(response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0") {
                const loanDetailsArray = Array.isArray(response?.data?.body?.record)
                ? response?.data?.body?.record
                : [response?.data?.body?.record];
                
                mainAmtArr = loanDetailsArray;
            } else {
                mainAmtArr = [];
                // setDetailsArr([]);
            }
            
            if(lateFeeResponse?.data?.header?.callStatus === "1" && lateFeeResponse?.data?.header?.reccount !== "0") {
                const loanDetailsArray = Array.isArray(lateFeeResponse?.data?.body?.record)
                ? lateFeeResponse?.data?.body?.record
                : [lateFeeResponse?.data?.body?.record];
                
                lateFeesArr = loanDetailsArray;
            }
            
            if(loanPaymentPlanRetrieveRes?.data?.header?.callStatus === "1" && loanPaymentPlanRetrieveRes?.data?.header?.reccount !== "0") {
                const userPaymentPlansArr = Array.isArray(loanPaymentPlanRetrieveRes?.data?.body?.record)
                ? loanPaymentPlanRetrieveRes?.data?.body?.record
                : [loanPaymentPlanRetrieveRes?.data?.body?.record];

                setUserLoanPaymentPlans(userPaymentPlansArr);
            }

            console.log("mainAmtArr=======================",mainAmtArr);
            console.log("lateFeesArr=======================",lateFeesArr);

            const finalArr = mergeLoanData(mainAmtArr, lateFeesArr);
            console.log("finalArr=======================",finalArr);
            setDetailsArr(finalArr);
            setOpenLoanDetailsDrawer(true)

        } catch (error) {
            
        }
    }

    const mergeLoanData = (mainAmtArr, lateFeesArr) => {
        const loanDataMap = new Map();
    
        // Process normal payments
        mainAmtArr.forEach(({ loanapplied, loanpayments }) => {
            const loanid = loanapplied.loanid;
            if (!loanDataMap.has(loanid)) {
                loanDataMap.set(loanid, { loanid, normalPayments: [], lateFees: [] });
            }
            
            const paymentWithDate = { ...loanapplied, paymentdate: loanpayments?.paymentdate || null };

            console.log("paymentWithDate---------",paymentWithDate)
            loanDataMap.get(loanid).normalPayments.push(paymentWithDate);
            // loanDataMap.get(loanid).normalPayments.push(loanapplied);
        });
    
        // Process late fees
        lateFeesArr.forEach(({ loanlatefees }) => {
            const loanid = loanlatefees.loanid;
            if (!loanDataMap.has(loanid)) {
                loanDataMap.set(loanid, { loanid, normalPayments: [], lateFees: [] });
            }
            loanDataMap.get(loanid).lateFees.push(loanlatefees);
        });
    
        // Convert Map back to array
        return Array.from(loanDataMap.values());
    };

    const handleMenuOpen = (event, loan) => {
        console.log("handleMenuOpen------------",loan)
        setAnchorEl(event.currentTarget);
        setSelectedLoan(loan);
    };

    const handleMenuClose = () => {
        console.log("handleMenuClose------------")
        setAnchorEl(null);
    };

    const handleViewDetails = (loan) => {
        setSelectedLoan(loan);
        // setOpenDetailsDialog(true);
        setOpenDetailsDrawer(true);
        handleMenuClose(); // close the menu
    };

    return (
        <Box className="loan-assignment-container">
            {
                isLoading ? 
                    (
                        <div className="text-center mt-5">
                            <span className="loader" />
                        </div>
                    ) :
                <>
                    <Box className="d-flex justify-content-between">
                        <Typography
                            sx={{
                                fontFamily: "'Nunito'",
                                fontStyle: "normal",
                                fontWeight: 500,
                                fontSize: "21.4825px",
                                color: "#3A3A3A",
                            }}
                            className="mb-2"
                        >
                            Disbursed Loans
                        </Typography>
                        <Box>
                            <Button
                                className="fs-size-12 paiy-blue text-white"
                                variant="contained"
                                color="primary"
                                onClick={() => setViewApprovedLoans(false)}
                            >
                                Return
                            </Button>
                        </Box>
                    </Box>

                    <Box>
                        <Box className="search-container">
                            <TextField
                                placeholder="Search by Product name, Requested amount, etc."
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                variant="standard"
                                fullWidth
                                onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                        handleSearch(); // Call your function on Enter key press
                                    }
                                }}
                                InputProps={{
                                    disableUnderline: true,
                                    sx: {
                                    borderRadius: "33px",
                                    color: "#000",
                                    },
                                    endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={handleSearch} edge="end">
                                        <SearchIcon />
                                        </IconButton>
                                    </InputAdornment>
                                    ),
                                }}
                                // InputProps={{ disableUnderline: true }}
                                sx={{ fontSize: "14px", borderRadius: "33px" }}
                            />
                        </Box>

                        {/* Date Pickers */}
                        <Box className="d-flex mt-3 gap-3">
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                inputFormat="YYYY-MM-DD"
                                label="Start Date"
                                fullWidth
                                margin="normal"
                                onChange={(newValue) => setStartDate(dayjs(newValue))}
                                value={startDate.toDate()}
                                InputLabelProps={{ 
                                    shrink: true,
                                    style: {
                                    fontSize: '12px',
                                    color: "inherit !important"
                                    }
                                }}
                                sx={{
                                    width: '25%', 
                                    marginTop: 2,
                                    marginBottom: 2,
                                    '& input': {
                                    padding: '8px 12px',
                                    color: "inherit !important"
                                    },
                                }}
                            />

                            <DatePicker
                                inputFormat="YYYY-MM-DD"
                                label="End Date"
                                fullWidth
                                margin="normal"
                                onChange={(newValue) => setEndDate(dayjs(newValue))}
                                value={endDate.toDate()}
                                InputLabelProps={{ 
                                    shrink: true,
                                    style: {
                                        fontSize: '12px',
                                        color: "inherit !important"
                                    }
                                }}
                                sx={{
                                    width: '25%', 
                                    marginTop: 2,
                                    marginBottom: 2,
                                    '& input': {
                                        padding: '8px 12px',
                                        color: "inherit !important"
                                    },
                                }}
                            />
                        </LocalizationProvider>
                        </Box>
                    </Box>
                    
                    <Box className="mt-4">
                        <TableContainer className="">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Currency Code</StyledTableCell>
                                        <StyledTableCell>Total Amount</StyledTableCell>
                                        {/* <StyledTableCell>Total Amount Applied</StyledTableCell> */}
                                        <StyledTableCell>Issued Date</StyledTableCell>
                                        <StyledTableCell>Late Fees</StyledTableCell>
                                        <StyledTableCell>Outstanding Principal</StyledTableCell>
                                        <StyledTableCell>Term Type</StyledTableCell>
                                        <StyledTableCell>Action</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {
                                    // loanList && loanList.length > 0 && loanList.map((row, index) => (
                                    loanList && loanList.length > 0 ? loanList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell align="center" className="">
                                                <div>{row?.loanissued?.currcode}</div>
                                            </TableCell>
                                            <TableCell align="right" className="">
                                                <div>{Number(row?.loanissued?.totalamount).toLocaleString("en-US", { minimumFractionDigits: 2 })}</div>
                                            </TableCell>
                                            {/* <TableCell align="center" className="">
                                                <div>{row?.loanissued?.totalamountapplied}</div>
                                            </TableCell> */}
                                            <TableCell align="center" className="">
                                                <div>{row?.loanissued?.issueddate}</div>
                                            </TableCell>
                                            <TableCell align="right" className="">
                                                <div>{Number(row?.loanissued?.outstandinglatefees).toLocaleString("en-US", { minimumFractionDigits: 2 })}</div>
                                            </TableCell>
                                            <TableCell align="right" className="">
                                                <div>{Number(row?.loanissued?.outstandingprinciple).toLocaleString("en-US", { minimumFractionDigits: 2 })}</div>
                                            </TableCell>
                                            <TableCell align="center" className="">
                                                <div>{row?.loanissued?.termtype}</div>
                                            </TableCell>
                                            {/* <TableCell align="center" className="">
                                                <Box className="d-flex gap-2">
                                                    <Button
                                                        className="action-button"
                                                        onClick={() => cancelLoanConfirmation(row)}
                                                        variant="contained"
                                                        size="small"
                                                        disabled={row?.loanissued?.fullypaidind == "2" || row?.loanissued?.fullypaidind == "1"}
                                                    >
                                                        {row?.loanissued?.fullypaidind == "2" ? "Cancelled" : row?.loanissued?.fullypaidind == "1" ? "Paid" : "Cancel"}
                                                    </Button>

                                                    <Button
                                                        className="action-button"
                                                        onClick={() => handleDetailsBtn(row)}
                                                        variant="contained"
                                                        size="small"
                                                        // disabled={row?.loanissued?.fullypaidind == "2" || row?.loanissued?.fullypaidind == "1"}
                                                    >
                                                        Details
                                                    </Button>
                                                </Box>
                                            </TableCell> */}
                                            <TableCell>
                                                <IconButton onClick={(e) => handleMenuOpen(e, row)}>
                                                    <MoreVertIcon />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    )) : (
                                        <TableRow>
                                            <TableCell align="center" colSpan={7}>
                                                <Typography variant="body1" color="textSecondary">
                                                No data available
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={loanList?.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />

                        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                            <MenuItem
                                disabled={selectedLoan?.outstandingamountwithlatefee <= 0}
                                onClick={() => {
                                    cancelLoanConfirmation(selectedLoan);
                                    handleMenuClose();
                                }}
                                disabled={selectedLoan?.loanissued?.fullypaidind == "2" || selectedLoan?.loanissued?.fullypaidind == "1"}
                            >
                                {selectedLoan?.loanissued?.fullypaidind == "2" ? "Cancelled" : selectedLoan?.loanissued?.fullypaidind == "1" ? "Paid" : "Cancel"}
                            </MenuItem>
                            <MenuItem
                                disabled={selectedLoan?.outstandingamountwithlatefee <= 0}
                                onClick={() => {
                                    handleDetailsBtn(selectedLoan)
                                    handleMenuClose();
                                }}
                            >
                                Payments Details
                            </MenuItem>
                            <MenuItem
                                disabled={selectedLoan?.outstandingamountwithlatefee <= 0}
                                onClick={() => {
                                    handleViewDetails(selectedLoan)
                                    handleMenuClose();
                                }}
                            >
                                View Details
                            </MenuItem>
                        </Menu>
                    </Box>
                </>
            }




            <CustomInputAlert
                show={showInputAlert?.showAlert}
                severity={showInputAlert?.severity}
                header={showInputAlert?.header}
                message={showInputAlert?.message}
                alertType={showInputAlert?.alertType}
                inputLabel={showInputAlert?.inputLabel}
                confirmButton={(value) => showInputAlert?.onConfirm(value)} 
                onClick={() => setShowInputAlert(false)}
            />

        <div className="loans-details-info-drawer">
            <BaseDrawer
                open={openDetailsDrawer}
                handleClose={() => setOpenDetailsDrawer(false)}
                height="85vh"
                className="loanProductInfoDrawer"
                overflow="auto"
            >
                {selectedLoan && (
                    <Box>
                        <Box className="user-accounts-tab">
                            <Box className="balance-container">
                                <Box className="row" display="flex" flexWrap="wrap" gap={4}>

                                    {/* Left: Loan Info */}
                                    <Box className="mb-4" flex={1}>
                                        <Typography
                                            sx={{
                                                fontWeight: 800,
                                                color: "#6b7280",
                                                fontFamily: "Nunito",
                                                fontSize: "16px",
                                                fontStyle: "normal",
                                            }}
                                        >
                                            Loan Info
                                        </Typography>

                                        <Box className="info-container">
                                            <Box className="info-type">Loan ID:</Box>
                                            <Box className="info-response">{selectedLoan?.loanissued?.loanid}</Box>
                                        </Box>
                                        <Box className="info-container">
                                            <Box className="info-type">User ID:</Box>
                                            <Box className="info-response">{selectedLoan?.loanissued?.userid}</Box>
                                        </Box>
                                        <Box className="info-container">
                                            <Box className="info-type">Issued Date:</Box>
                                            <Box className="info-response">{selectedLoan?.loanissued?.issueddate}</Box>
                                        </Box>
                                        <Box className="info-container">
                                            <Box className="info-type">Due Amount:</Box>
                                            <Box className="info-response">{(Number(selectedLoan?.loanissued?.outstandingprinciple) + Number(selectedLoan?.loanissued?.outstandingfees) + Number(selectedLoan?.loanissued?.outstandinglatefees)).toLocaleString()}</Box>
                                        </Box>
                                        <Box className="info-container">
                                            <Box className="info-type">Due Date:</Box>
                                            <Box className="info-response">{selectedLoan?.loanissued?.loanduedate}</Box>
                                        </Box>
                                        <Box className="info-container">
                                            <Box className="info-type">Currency Code:</Box>
                                            <Box className="info-response">{selectedLoan?.loanissued?.currcode}</Box>
                                        </Box>
                                        <Box className="info-container">
                                            <Box className="info-type">External Ref No:</Box>
                                            <Box className="info-response">{selectedLoan?.loanissued?.externalrefno}</Box>
                                        </Box>
                                        <Box className="info-container">
                                            <Box className="info-type">Loan Confirmed:</Box>
                                            <Box className="info-response">
                                            {selectedLoan?.loanissued?.loanconfirmed === "1" ? "Yes" : "No"}
                                            </Box>
                                        </Box>
                                        <Box className="info-container">
                                            <Box className="info-type">Cancellation Reason:</Box>
                                            <Box className="info-response">
                                            {selectedLoan?.loanissued?.cancellationreason || "N/A"}
                                            </Box>
                                        </Box>
                                        <Box className="info-container">
                                            <Box className="info-type">Cancellation Date:</Box>
                                            <Box className="info-response">
                                            {selectedLoan?.loanissued?.cancellationdatetime || "N/A"}
                                            </Box>
                                        </Box>
                                        <Box className="info-container">
                                            <Box className="info-type">Loan Upgraded:</Box>
                                            <Box className="info-response">
                                            {selectedLoan?.loanissued?.loanupgraded === "1" ? "Yes" : "No"}
                                            </Box>
                                        </Box>
                                    </Box>

                                    <Box flex={1}>
                                        <Typography
                                            sx={{
                                                fontWeight: 800,
                                                color: "#6b7280",
                                                fontFamily: "Nunito",
                                                fontSize: "16px",
                                                fontStyle: "normal",
                                            }}
                                        >
                                            Financial Info
                                        </Typography>

                                        <Box className="info-container">
                                            <Box className="info-type">Issued Amount:</Box>
                                            <Box className="info-response">{Number(selectedLoan?.loanissued?.issuedamount).toLocaleString()}</Box>
                                        </Box>
                                        <Box className="info-container">
                                            <Box className="info-type">Total Amount:</Box>
                                            <Box className="info-response">{Number(selectedLoan?.loanissued?.totalamount).toLocaleString()}</Box>
                                        </Box>
                                        <Box className="info-container">
                                            <Box className="info-type">Total Fees:</Box>
                                            <Box className="info-response">{Number(selectedLoan?.loanissued?.totalfees).toLocaleString()}</Box>
                                        </Box>
                                        <Box className="info-container">
                                            <Box className="info-type">Outstanding Loan:</Box>
                                            <Box className="info-response">{(Number(selectedLoan?.loanissued?.outstandingprinciple) + Number(selectedLoan?.loanissued?.outstandingfees) + Number(selectedLoan?.loanissued?.outstandinglatefees)).toLocaleString()}</Box>
                                        </Box>
                                        <Box className="info-container">
                                            <Box className="info-type">Outstanding Principal:</Box>
                                            <Box className="info-response">{Number(selectedLoan?.loanissued?.outstandingprinciple).toLocaleString()}</Box>
                                        </Box>
                                        <Box className="info-container">
                                            <Box className="info-type">Outstanding Fees:</Box>
                                            <Box className="info-response">{Number(selectedLoan?.loanissued?.outstandingfees).toLocaleString()}</Box>
                                        </Box>
                                        <Box className="info-container">
                                            <Box className="info-type">Outstanding Late Fees:</Box>
                                            <Box className="info-response">{Number(selectedLoan?.loanissued?.outstandinglatefees).toLocaleString()}</Box>
                                        </Box>
                                        <Box className="info-container">
                                            <Box className="info-type">Outstanding Principal & Fees:</Box>
                                            <Box className="info-response">{Number(selectedLoan?.loanissued?.outstandingprincipleandfees).toLocaleString()}</Box>
                                        </Box>
                                        <Box className="info-container">
                                            <Box className="info-type">Total Amount Applied:</Box>
                                            <Box className="info-response">{Number(selectedLoan?.loanissued?.totalamountapplied).toLocaleString()}</Box>
                                        </Box>
                                        <Box className="info-container">
                                            <Box className="info-type">Total Principal & Fees:</Box>
                                            <Box className="info-response">{Number(selectedLoan?.loanissued?.totalprincipleandfees).toLocaleString()}</Box>
                                        </Box>
                                        <Box className="info-container">
                                            <Box className="info-type">Tax Amount:</Box>
                                            <Box className="info-response">{Number(selectedLoan?.loanissued?.taxamount).toLocaleString()}</Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                )}
            </BaseDrawer>
        </div>

        <BaseDrawer
            open={openLoanDetailsDrawer}
            handleClose={() => setOpenLoanDetailsDrawer(false)}
            height="85vh"
        >
            <LoanDetails4Pay selectedLoan={selectedLoan} loanDetailsArr={loanDetailsArr} userLoanPaymentPlans={userLoanPaymentPlans} />
        </BaseDrawer>
        </Box>
    );
};

export default LoansApprovedPage;
